import styled from 'styled-components/macro';


export const StyledDivider = styled.div`
    height: 1px;
    background-color:#E2E2E2;
    margin-top: 20px;
    margin-bottom:20px;
`;
